import type { JSX, ReactNode } from 'react'
import { cn } from '#src/cn.ts'

export interface TypographyPageTitleProps {
  className?: string
  children: ReactNode
}

export function TypographyPageTitle({
  className,
  children,
}: TypographyPageTitleProps): JSX.Element {
  return (
    <h1
      className={cn(
        'py-0.5', // We want the total height to be 10 so that it matches Button. Buttons are often placed alongside PageTitle.
        className
      )}
    >
      {children}
    </h1>
  )
}
